import React, { useState, useEffect } from 'react';
import './EmailModal.css';
import apiService from '../services/api';
import { triggerHaptic, openExternalLink } from '../services/telegram';

export const EMAIL_STORAGE_KEY = 'beznet_email';

export function loadStoredEmail() {
  try {
    if (typeof localStorage === 'undefined') return '';
    return localStorage.getItem(EMAIL_STORAGE_KEY) || '';
  } catch {
    return '';
  }
}

export function isValidEmail(value) {
  const trimmed = (value || '').trim();
  return /^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(trimmed);
}

function storeEmail(email) {
  try {
    if (typeof localStorage === 'undefined') return;
    localStorage.setItem(EMAIL_STORAGE_KEY, email);
  } catch {
  }
}

function EmailModal({ isOpen, onClose, userId, plan, tariffId, paymentMethod = 'card' }) {
  const [email, setEmail] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (isOpen) {
      setEmail(loadStoredEmail());
      setError(null);
      setIsSubmitting(false);
    }
  }, [isOpen]);

  if (!isOpen) return null;

  const handleBackgroundClick = () => {
    triggerHaptic();
    onClose?.();
  };

  const handleCloseClick = (e) => {
    e.stopPropagation();
    triggerHaptic();
    onClose?.();
  };

  const handleSubmit = async () => {
    triggerHaptic();
    if (!userId || !plan || isSubmitting) return;
    const trimmed = (email || '').trim();
    if (!trimmed || !isValidEmail(trimmed)) {
      setError('Введите корректный email для получения чеков.');
      return;
    }

    setIsSubmitting(true);
    setError(null);
    storeEmail(trimmed);

    const durationDays = plan ? Math.round(plan.months * 30.44) : 30;
    const tariffPlan = 'pro';
    const origin = typeof window !== 'undefined' ? window.location.origin : '';
    const apiBase = process.env.REACT_APP_API_BASE_URL || '';
    const successBase =
      (origin && origin.startsWith('https://') ? origin : (process.env.REACT_APP_SUCCESS_BASE_URL || '')).replace(/\/$/, '');
    let returnUrl = `${successBase}/success.html`;
    if (apiBase) {
      const joiner = returnUrl.includes('?') ? '&' : '?';
      returnUrl = `${returnUrl}${joiner}api=${encodeURIComponent(apiBase)}`;
    }

    try {
      const res = await apiService.subscriptionCheckout({
        userid: userId,
        tariff_plan: tariffPlan,
        duration_days: durationDays,
        amount: String(plan.price),
        return_url: returnUrl,
        payment_method: paymentMethod,
        email: trimmed,
        autorenew_consent: false,
        autorenew_terms_version: '2026-08-12',
      });
      if (res && res.confirmation_url) {
        try {
          if (res.payment_id && typeof sessionStorage !== 'undefined') {
            sessionStorage.setItem('beznet_pending_payment_id', String(res.payment_id));
          }
        } catch (_) {}
        openExternalLink(res.confirmation_url);
        onClose?.();
        return;
      }
      setError('Не удалось получить ссылку на оплату');
    } catch (e) {
      const msg = (e && e.message) ? String(e.message) : '';
      if (/Load failed|Нет связи|CORS|fetch|network|Failed to fetch|Failed to load|status 0|TypeError.*fetch/i.test(msg)) {
        setError('Не удалось подключиться к серверу. Проверьте интернет или CORS.');
      } else {
        setError(msg || 'Ошибка при создании платежа');
      }
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className="email-overlay" onClick={handleBackgroundClick}>
      <div className="email-modal" onClick={(e) => e.stopPropagation()}>
        <button
          type="button"
          className="email-close"
          onClick={handleCloseClick}
          aria-label="Закрыть"
        >
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M18 6L6 18M6 6L18 18" stroke="white" strokeWidth="2" strokeLinecap="round" />
          </svg>
        </button>

        <h2 className="email-title">Почта</h2>
        <p className="email-subtitle">Укажите почту для получения чеков</p>

        <input
          type="email"
          className="email-input"
          placeholder="example@gmail.com"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          inputMode="email"
        />

        {error && <p className="email-error">{error}</p>}

        <button
          type="button"
          className="email-save-button"
          onClick={handleSubmit}
          disabled={isSubmitting || !userId || !plan}
        >
          {isSubmitting ? 'Загрузка…' : 'Сохранить'}
        </button>
      </div>
    </div>
  );
}

export default EmailModal;

